import React, { useState } from "react";
import { useAuth } from "../../../components/context/AuthProvider";
import { Link } from "react-router-dom";
import type { CampaignView, CampaignViewCharacter } from "../../../types/types";

interface CampaignCharactersProps {
  campaign: CampaignView;
  onUpdate: () => void;
}

const CampaignCharacters: React.FC<CampaignCharactersProps> = ({ campaign }) => {
  const [characters] = useState(campaign.characters || []);
  const auth = useAuth();

  const renderCharacterName = (char: CampaignViewCharacter) => {
    return char.userId + "" === auth.get("userId") + "" ? (
      <Link
        to={`/protected/characters/${char.id}`}
        className="text-amber-400 hover:text-amber-300 transition-colors"
      >
        {char.name}
      </Link>
    ) : (
      <span className="text-white">{char.name}</span>
    );
  };

  return (
    <div className="space-y-6">
      <h2 className="text-base font-semibold text-amber-400 tracking-wide mb-4">Campaign Heroes</h2>
      <div className="grid gap-px md:grid-cols-2 lg:grid-cols-3 bg-zinc-800">
        {characters.map((char) => (
          <div
            key={char.id}
            className="bg-zinc-900 p-5 flex flex-col gap-2 hover:bg-zinc-800 transition-colors duration-150"
          >
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-amber-900/30 border border-amber-800/50 flex items-center justify-center text-amber-400 font-semibold text-lg">
                {char.name.charAt(0)}
              </div>
              <div>
                <span className="font-semibold text-white text-base">
                  {renderCharacterName(char)}
                </span>
                <span className="ml-2 text-xs text-zinc-500">#{char.id}</span>
              </div>
            </div>
            <div className="text-zinc-300 text-sm mb-1">
              <span className="text-zinc-500">Description:</span>{" "}
              {char.description || <span className="italic text-zinc-600">No description</span>}
            </div>
            <div className="text-zinc-300 text-sm mb-1">
              <span className="text-zinc-500">Notes:</span>{" "}
              {char.notes || <span className="italic text-zinc-600">No notes</span>}
            </div>
            <div className="flex items-center gap-2 mt-2">
              <span className="text-xs text-zinc-600">
                Player: {char.username || `User #${char.userId}`}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CampaignCharacters;
